import React from "react";
import { NAV } from "@/constants/testIds";
import { useSiteContent } from "@/lib/siteContent";

const LINKS = [
  { id: NAV.linkAbout, label: "About", href: "#about" },
  { id: NAV.linkProcess, label: "How It Works", href: "#process" },
  { id: NAV.linkFounder, label: "Founder", href: "#founder" },
  { id: NAV.linkTestimonials, label: "Stories", href: "#testimonials" },
  { id: NAV.linkFAQ, label: "FAQ", href: "#faq" },
];

export const Wordmark = ({ content, size = "md" }) => {
  if (content.logo_image) {
    const h = size === "lg" ? "h-16" : "h-10";
    return (
      <img
        src={content.logo_image}
        alt={`${content.logo_text_primary}${content.logo_text_accent}`}
        className={`${h} w-auto object-contain`}
      />
    );
  }
  const primaryCls =
    size === "lg"
      ? "text-6xl lg:text-7xl"
      : "text-3xl";
  const accentCls =
    size === "lg" ? "text-7xl -ml-1" : "text-4xl -ml-1";
  const primaryColor = size === "lg" ? "text-white" : "text-[#0A2342]";
  return (
    <div className="flex items-baseline gap-1">
      <span
        style={{ fontFamily: content.logo_font_primary || '"Playfair Display", serif' }}
        className={`${primaryCls} tracking-tight ${primaryColor} font-bold leading-none`}
      >
        {content.logo_text_primary}
      </span>
      <span
        style={{ fontFamily: content.logo_font_accent || '"Great Vibes", cursive' }}
        className={`${accentCls} text-[#CBA358] leading-none`}
      >
        {content.logo_text_accent}
      </span>
    </div>
  );
};

export const Navbar = () => {
  const { content } = useSiteContent();
  return (
    <header
      data-testid={NAV.root}
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#FDFBF7]/80 border-b border-[#E5DFD3]/70"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid={NAV.logo} className="group">
          <Wordmark content={content} />
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={l.id}
              className="text-[13px] uppercase tracking-[0.18em] font-medium text-[#5C636A] hover:text-[#0A2342] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#booking"
          data-testid={NAV.ctaBook}
          className="hidden sm:inline-flex items-center gap-2 bg-[#0A2342] text-white px-5 py-3 text-sm font-medium uppercase tracking-wider hover:bg-[#173B63] transition-colors"
        >
          Book Session
          <span aria-hidden>→</span>
        </a>
      </div>
    </header>
  );
};

export default Navbar;
